import { FunctionComponent, ReactNode } from "react";

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faChevronUp } from "@fortawesome/pro-regular-svg-icons";

import { Spinner } from "../Spinner/Spinner";
import { Icon } from "../Icon/Icon";

interface FooterPopoverGroupProps {
	icon: IconDefinition;
	label: string;
	isOpen: boolean;
	onToggle: () => void;
	isLoading?: boolean;
	loadingLabel?: string;
	children: ReactNode;
	/** When true, renders with white-on-dark styling for the floating bulk action bar */
	dark?: boolean;
	/** Horizontal alignment of the popover relative to its trigger. Defaults to "left". */
	align?: "left" | "right";
}

export const FooterPopoverGroup: FunctionComponent<FooterPopoverGroupProps> = ({
	icon,
	label,
	isOpen,
	onToggle,
	isLoading,
	loadingLabel,
	children,
	dark,
	align = "left",
}) => {
	return (
		<div className="relative">
			{isLoading ? (
				<div className="flex items-center justify-center">
					<Spinner color={dark ? "#FFFFFF" : "#6B7280"} />
					<div className={`flex flex-row text-sm ml-1 ${dark ? "text-white" : "text-gray-700"}`}>
						{loadingLabel}
					</div>
				</div>
			) : dark ? (
				<button
					className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium cursor-pointer text-white hover:bg-white-semi transition-colors"
					type="button"
					onClick={onToggle}
				>
					<Icon className="w-3.5 h-3.5" icon={icon} />
					<span className="whitespace-nowrap">{label}</span>
					<Icon className="w-2.5 h-2.5" icon={faChevronUp} />
				</button>
			) : (
				<div
					className="self-right items-center flex gap-1.5 cursor-pointer group"
					onClick={onToggle}
				>
					<Icon className="w-5 text-gray-700 group-hover:text-brand-light" icon={icon} />
					<div className="flex flex-row text-sm text-gray-700 group-hover:text-brand-light whitespace-nowrap">
						{label}
					</div>
					<Icon className="w-3 text-gray-700 group-hover:text-brand-light" icon={faChevronUp} />
				</div>
			)}
			{isOpen && (
				<div
					className={`absolute bottom-full mb-4 ${align === "right" ? "right-0" : "left-0"} w-[200px] bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden z-[2000]`}
				>
					{children}
				</div>
			)}
		</div>
	);
};
